import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {Questionnaires} from '../Questionnaires.ts';
import {QuestionnairesApi} from '../../../apis/QuestionnairesApi/QuestionnairesApi.ts';

export function useDeleteQuestionnaire() {
    const queryClient = useQueryClient();

    return useMutation<number, AppMedError, string>({
        mutationKey: [QueryKeys.questionnaires],
        mutationFn: async (entityId: string) => {
            if (!entityId) 
                return 0;
            
            await QuestionnairesApi.deleteQuestionnaire(entityId);

            queryClient.setQueryData<Questionnaires[]>([QueryKeys.questionnaires], (prev) => {
                return prev ? prev.filter(el => el.id !== Number(entityId)) : [];
            });

            return Number(entityId);
        },
        onError: (error) => {
            console.error('Erreur dans la mutation :', error);
        }
    });
}
